// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__31t6m","inner":"Form_inner__OrpTz","range":"Form_range__2GlpQ","name":"Form_name__3ukRV","actions":"Form_actions__1P9L-"};